import Vue from 'vue';
import Vuex from 'vuex';

import shoppingCart from './modules/shopping-cart';
import checkout from './modules/checkout';
import expressQuote from './modules/express-quote';
import checkoutErp from './modules/erp';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    shoppingCart,
    checkout,
    expressQuote,
    checkoutErp,
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
});



// WEBPACK FOOTER //
// ./src/store/index.js